import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { API } from '../../API/API';
import DiwoAISetup from './DiwoAISetup';
import ButtonSecondaryIcon from '../../components/ButtonSecondaryIcon/ButtonSecondaryIcon';
import FieldText from '../../components/FieldText/FieldText';
import { SentIcon } from '../../svg/SentIcon';
import { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { ChatCheck } from '../../svg/ChatCheck';
import LoadSpin from '../../components/LoadSpin/LoadSpin';
import { StarIcon } from '../../svg/StarIcon';
import { Col, Row, Space } from 'antd';
import ChatCart from '../../components/ChatCart/ChatCart';
import insPic from '../../images/background/instruction.png';
import insPic2 from '../../images/background/instruction2.png';
import TDBLogo from '../../images/background/tdbfileCart.png';
import { useNavigate } from 'react-router-dom';
import AISuggestCont from '../../components/AISuggestCont/AISuggestCont';
import AIQuestionIcon from '../../svg/AIQuestionIcon';
import AILike from '../../svg/AILike';
import AIDislike from '../../svg/AIDislike';
import AIDivider from '../../svg/AIDivider';
import { Dialog, DialogType } from '@fluentui/react';
import FieldTextArea from '../../components/FieldTextArea/FieldTextArea';
import ButtonDefault from '../../components/ButtonDefault/ButtonDefault';
import AICounter from '../../svg/AICounter';
import PaymentPanel from '../Market/Dtl/PaymentPanel';
import { corporateStrategyData } from '../../const/Const';
import ListIcon from '../../svg/ListIcon';
import DiwoAIHistory from './DiwoAIHistory';

const DiwoAI = (props) => {

    const navigate = useNavigate();

    const { userInfo } = useContext(UserContext);

    const contentEndRef = useRef();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDiwoAI, setShowDiwoAI] = useState(false);
    const [loadingSent, setLoadingSent] = useState(false);
    const [chatId, setChatId] = useState();
    const [initChatCount] = useState(10);
    const [chatCount, setChatCount] = useState(initChatCount);
    const [askText, setAskText] = useState();

    const [loadFeedback, setLoadFeedback] = useState();
    const [showFeedback, setShowFeedback] = useState();
    const [feedbackNote, setFeedbackNote] = useState();

    const [loadingStart, setLoadingStart] = useState(false);
    const [showPayment, setShowPayment] = useState(false);
    const [showHistory, setShowHistory] = useState(false);

    const getData = async (pChatId) => {
        let tData = [];
        let tChatId = pChatId ? pChatId : null;
        let tChatCount = initChatCount;
        let tLastChat = null;
        try {
            setLoading(true);

            if (!tChatId) {
                await API.get("/api/odata/ai/history").then(response => {
                    if (response?.status == 200 && response?.data?.rettype == 0) {
                        if (response?.data?.retdata?.length > 0) {
                            tLastChat = response?.data?.retdata[response?.data?.retdata?.length - 1];
                            tChatId = tLastChat?.aichatid;
                        }
                    }
                });
            }

            if (tChatId > 0) {
                await API.get("/api/odata/ai/history?aichatid=" + tChatId).then(response => {
                    if (response?.status == 200 && response?.data?.rettype == 0) {
                        if (response?.data?.retdata?.length > 0) {

                            if (response?.data?.retparams?.length > 1) {
                                tChatCount = response?.data?.retparams[1];
                            }

                            tData.push({
                                info: true,
                                body: "Танай компаний нэр болон бусад мэдээллийг ChatGPT руу илгээгээгүй. Зөвхөн таны оруулсан тоонуудыг илгээв"
                            });
                            var isFirst = true;
                            response?.data?.retdata.map(r => {
                                if (r?.question) {
                                    tData.push({
                                        user: true,
                                        body: r?.question
                                    });
                                } else if (tLastChat?.strategiesjson && isFirst) {
                                    tData.push({ body: "<div>Танай компанийн стратеги сонголт юу вэ?</div>" });
                                    tData.push({ user: true, body: corporateStrategyData?.filter(r => JSON.parse(tLastChat.strategiesjson).includes(r.key))?.map(r => r.text).join(", ") });
                                    isFirst = false;
                                }

                                tData.push({
                                    body: r?.message
                                });
                            });
                        }
                    }
                });
            }
        } finally {
            setLoading(false);
        }


        setData(tData);
        setChatId(tChatId);
        setChatCount(tChatCount);
    }

    useEffect(() => {
        getData(null);
        var addScript = document.createElement("script");
        addScript.setAttribute(
            "src",
            "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        );
        document.body.appendChild(addScript);
        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                {
                    pageLanguage: "en",
                    includedLanguages: 'en,mn,ru,fr,ja',
                    autoDisplay: false
                },
                "google_translate_element"
            );
        };
        return () => {
            document.body.removeChild(addScript);
        };
    }, []);


    const onFeedback = async (pId, pType, pValue, pIndex, pContentBody) => {
        let tId = pId ? pId : moment().unix();
        try {
            setLoadFeedback(pIndex);
            await API.post("/api/humanresource/Organization/setFeedback?id=" + tId + "&feedbacktype=" + pType + "&feedbackvalue=" + pValue + "&pageurl=/hrsuite/home&contentbody=" + (pContentBody ? JSON.stringify(pContentBody) : "")).then(response => {
            });
        } finally {
            setLoadFeedback();
            setShowFeedback(pId ? null : tId);
        }
    }

    const afterSent = async (pData, pStrategy) => {
        setShowDiwoAI(false);
        let tResp = null;
        let tData = [];
        let tChatId = null;
        let tChatCount = initChatCount;

        try {

            tData.push({
                info: true,
                body: "Танай компаний нэр болон бусад мэдээллийг ChatGPT руу илгээгээгүй. Зөвхөн таны оруулсан тоонуудыг илгээв"
            });

            setData([...tData]);

            setLoadingSent(true);
            let tDataParam = {};
            pData?.map(r => {
                tDataParam = { ...tDataParam, [r.id]: parseFloat(r.value?.toString().replaceAll(",", "")) }
            });

            await API.post("/api/odata/ai", { metrics: tDataParam, strategies: pStrategy?.map(r => r.key) }).then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    tResp = response?.data?.retdata;
                    if (response?.data?.retparams?.length > 0 && response?.data?.retparams[0] > 0) {
                        tChatId = response?.data?.retparams[0];
                        if (response?.data?.retparams?.length > 1) {
                            tChatCount = response?.data?.retparams[1];
                        }
                    }
                }
            });

        } finally {
            setLoadingSent(false);
        }

        if (tResp) {
            tData.push({ body: "<div>Танай компанийн стратеги сонголт юу вэ?</div>" });
            tData.push({ user: true, body: pStrategy?.map(r => r.text).join(", ") });
            if (Array.isArray(tResp)) {
                tResp.map(r => {
                    tData.push({
                        body: r
                    });
                });
            } else
                tData.push({ body: tResp });
        }

        setData([...tData]);
        setChatId(tChatId);
        setChatCount(tChatCount);
    }

    const onChangeAskText = (pValue, pIsEnter) => {
        setAskText(pValue);
        if (pIsEnter) {
            onSentAskText();
        }
    }

    useEffect(() => {
        if (contentEndRef?.current) {
            contentEndRef?.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [data])

    const onSentAskText = async (pText) => {
        if (chatId > 0 && (askText || pText)) {

            let tAskText = pText ? pText : askText;
            let tChatCount = initChatCount;

            let tData = [...data];
            tData.push({
                user: true,
                body: tAskText
            });

            setData([...tData]);
            setAskText();

            try {
                setLoadingSent(true);
                await API.post("/api/odata/ai/chat", { chatID: chatId, question: tAskText }).then(response => {
                    if (response?.status == 200 && response?.data?.rettype == 0) {
                        tData.push({ body: response?.data?.retdata });
                        if (response?.data?.retparams?.length > 1) {
                            tChatCount = response?.data?.retparams[1];
                        }
                    }
                });
            } finally {
                setLoadingSent(false);
            }
            setData([...tData]);
            setChatCount(tChatCount);
        }
    }

    const onLink = (pUrl) => {
        window.open(pUrl, "_blank");
    }

    const onNav = (pUrl) => {
        navigate(pUrl);
    }

    const onStart = async () => {

        let tShowDiwoAI = true;

        try {
            setLoadingStart(true);
            await API.get("/api/odata/ai").then(response => {
                if (response?.status == 200) {
                    tShowDiwoAI = true;
                }
            }).catch(e => {
                if (e?.response?.status == 402) {
                    tShowDiwoAI = false;
                }
            });
        } finally {
            setLoadingStart(false);
        }

        if (tShowDiwoAI) {
            setShowDiwoAI(true);
        } else {
            setShowPayment(true);
        }
    }

    let tSuggestQuestion = ["Explain these tasks in simple terms?", "Explain these recommendations in simple term?", "Explain these KPIs in simple term?"];
    tSuggestQuestion = tSuggestQuestion.filter(r => !data?.map(ri => ri.body).includes(r));

    return (
        <div>
            {loading && <LoadSpin space />}
            <div style={{ visibility: !loading ? 'visible' : 'hidden', height: 30, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingLeft: 16, paddingRight: 16 }}>
                <div onClick={() => { setShowHistory(true); }} style={{ height: 24, width: 24, cursor: 'pointer' }}>
                    <ListIcon />
                </div>
            </div>
            <div style={{ height: 'calc(100vh - 78px)', width: '100%', boxSizing: 'border-box', padding: '0px 32px 32px 32px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ height: '80vh', overflow: 'auto', width: '80%' }}>
                    <div style={{ boxSizing: 'border-box' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 6 }}>
                            <div className="circles" id="circles">
                                <div className="circle"></div>
                                <div className="circle"></div>
                                <div className="circle"></div>
                                <div className="circle"></div>
                            </div>
                            <div style={{ marginTop: 20, color: '#3B3B3B', fontSize: 20, fontWeight: 600, textAlign: 'center' }}>
                                Сайн уу, {userInfo?.fullname}.
                            </div>
                            <div style={{ marginTop: 8, color: '#3B3B3B', fontSize: 16, textAlign: 'center' }}>
                                ChatGPT суурьтай хүний нөөцийн ухаалаг туслахын хэсэгт тавтай морил!
                            </div>
                            <div style={{ width: '100%', marginTop: 20, overflow: 'hidden' }}>
                                <Row gutter={[16, 16]} justify={'center'}>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }} >
                                        <ChatCart onClick={() => onLink("https://www.youtube.com/watch?v=A2cKQyDBtBA")} title="Ажилтан нэмэх заавар">
                                            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <img src={insPic2} height={80} alt='' />
                                            </div>
                                        </ChatCart>
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                        <ChatCart onClick={() => onNav("/hrsuite/market/5")} title="Шинэ маркетууд">
                                            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                                                <img src={TDBLogo} height={56} />
                                                <div style={{ marginLeft: 8 }}>
                                                    <div className='oneLineEllipsis' style={{ fontSize: 14, fontWeight: 600, maxWidth: "40%" }}>ХХБанкны цалингийн шилжүүлгийн файл</div>
                                                    <div className='multiLineEllipsis' style={{ marginTop: 2, fontSize: 12, color: '#605E5C', maxWidth: "40%" }}>Цалингийн шилжүүлгийн файлаа Худалдаа Хөгжлийн Банкны форматаар авах боломжтой болно.</div>
                                                </div>
                                            </div>
                                        </ChatCart>
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 6 }}>
                                        <ChatCart onClick={() => onLink("https://www.youtube.com/watch?v=pmbBi41gabo")} title="Ажил эрхлэлтийн түүх нэмэх заавар">
                                            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <img src={insPic} height={80} alt='' />
                                            </div>
                                        </ChatCart>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="translate" style={{ marginTop: 16 }}>
                            <div style={{ width: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>
                                <div style={{ visibility: data?.length > 0 && !loadingSent ? 'visible' : 'hidden' }}>
                                    <div id="google_translate_element"></div>
                                </div>
                            </div>
                            {data?.map((r, index) => {
                                if (r?.info) {
                                    return (
                                        <div ref={data?.length == index + 1 && !loadingSent ? contentEndRef : null} key={index} style={{ marginTop: 16, maxWidth: '90%', boxSizing: 'border-box', display: 'flex', alignItems: 'center' }}>
                                            <div style={{ width: 16, height: 16 }}>
                                                <ChatCheck />
                                            </div>
                                            <div style={{ color: '#3B3B3B', fontSize: 14, marginLeft: 8 }}>
                                                {r?.body}
                                            </div>
                                        </div>
                                    );
                                } if (r?.user) {
                                    return (
                                        <div ref={data?.length == index + 1 && !loadingSent ? contentEndRef : null} key={index} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                                            <div style={{ maxWidth: '90%', boxSizing: 'border-box', background: '#0358A7', padding: 12, borderRadius: 8, border: '0.5px solid #C8C6C4', boxShadow: '0px 3px 3px 0px rgba(0, 0, 0, 0.10)', color: '#000', fontSize: 14, color: '#FFF' }}>
                                                {r.body}
                                            </div>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div ref={data?.length == index + 1 && !loadingSent ? contentEndRef : null} key={index} style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 16 }}>
                                            <div className='AITextContiner' style={{ maxWidth: '90%', boxSizing: 'border-box', background: '#FFF', padding: 12, borderRadius: 8, border: '0.5px solid #C8C6C4', boxShadow: '0px 3px 3px 0px rgba(0, 0, 0, 0.10)', color: '#000', fontSize: 14, position: 'relative' }}>
                                                <div className='AITextContinerMore' style={{ position: 'absolute', marginTop: -44, marginLeft: -12, height: 28, background: '#FFFFFF', padding: 4, boxSizing: 'border-box', borderRadius: 2, border: '0.5px solid #C8C6C4', boxShadow: '0px 3px 3px 0px rgba(0, 0, 0, 0.10)', display: 'flex', alignItems: 'center', padding: '0px 8px' }}>
                                                    {loadFeedback == index ? <LoadSpin small /> : (
                                                        <Space size={8}>
                                                            <div onClick={() => onFeedback(null, "type", "Таалагдаж байна", index, r.body)} style={{ width: 16, height: 16, cursor: 'pointer' }}>
                                                                <AILike />
                                                            </div>
                                                            <div style={{ width: 1, height: 20 }}>
                                                                <AIDivider />
                                                            </div>
                                                            <div onClick={() => onFeedback(null, "type", "Таалагдахгүй байна", index, r.body)} style={{ width: 16, height: 16, cursor: 'pointer' }}>
                                                                <AIDislike />
                                                            </div>
                                                        </Space>
                                                    )}
                                                </div>
                                                {r.body && (
                                                    <div dangerouslySetInnerHTML={{ __html: r.body }} />
                                                )}
                                            </div>
                                        </div>
                                    );
                                }
                            })}
                            {loadingSent ? (
                                <div ref={contentEndRef} style={{ marginTop: 16, maxWidth: '90%', boxSizing: 'border-box', display: 'flex', alignItems: 'center' }}>
                                    <div style={{ width: 16, height: 16 }}>
                                        < LoadSpin small />
                                    </div>
                                    <div style={{ color: '#3B3B3B', fontSize: 14, marginLeft: 8 }}>
                                        Таны өгөгдөлд тулгуурлан мэдээлэл боловсруулж байна.
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {data?.length >= 4 && tSuggestQuestion?.length > 0 ? (
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                                <Space size={8}>
                                    <div style={{ width: 20, height: 20 }}>
                                        <AIQuestionIcon />
                                    </div>
                                    {tSuggestQuestion?.map((r, index) => {
                                        return (
                                            <AISuggestCont key={index} onClick={() => onSentAskText(r)} text={r} />
                                        );
                                    })}
                                </Space>
                            </div>
                        ) : null}
                    </div>
                </div>
                <div style={{ marginTop: 16, width: '80%' }}>
                    <Row gutter={[16, 16]} justify={'center'}>
                        <Col>
                            <div key={data?.length}>
                                {loadingStart ? <div style={{ minWidth: 150, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}> <LoadSpin /> </div> : <ButtonSecondaryIcon customIcon={<StarIcon />} onClick={onStart} text={data?.length == 0 ? "Эхлэх" : "Дахин эхлэх"} />}
                            </div>
                        </Col>
                        <Col flex="auto" >
                            <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                <div key={data?.length} style={{ position: 'relative', flex: 1 }}>
                                    <FieldText hideTitle disable={chatId > 0 && chatCount > 0 ? false : true} placeholder="Асуух зүйлс байна уу?" onChanged={(key, text, field, fieldname) => onChangeAskText(key, false)} onEnterClicked={(pValue) => onChangeAskText(pValue, true)} keyfield='askText' defaultValue={askText} />
                                    <div style={{ position: 'absolute', top: 6, right: 6 }}>
                                        {chatId > 0 && loadingSent ? <div style={{ marginTop: 2 }}><LoadSpin small /></div> : (
                                            <div onClick={() => onSentAskText()} style={{ width: 20, height: 20, cursor: 'pointer' }}>
                                                <SentIcon />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div style={{ height: 32, width: 65, background: '#E9E9E9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div style={{ height: 20, width: 20, marginRight: 4 }}>
                                        <AICounter />
                                    </div>
                                    <div style={{ fontSize: 16, fontWeight: 600 }}>
                                        {chatCount}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div style={{ marginTop: 16, fontSize: 12, color: '#212121' }}>
                    ChatGPT нь зарим асуултанд бодитой бус хариулт өгөх тохиолдол байдаг болохыг анхаарна уу. Англи хэлээр илүү сайн хариулдаг.
                </div>
            </div>
            {showDiwoAI ? <DiwoAISetup isOpen={showDiwoAI} onDismiss={() => { setShowDiwoAI(false) }} afterSent={afterSent} /> : null}
            {showPayment ? <PaymentPanel id={7} title='Төлбөр төлөх' isOpen={showPayment} onDismiss={() => { setShowPayment(false); }} /> : null}
            {showHistory ? <DiwoAIHistory isOpen={showHistory} onDismiss={() => { setShowHistory(false); }} onHistory={getData} /> : null}
            <Dialog
                hidden={showFeedback ? false : true}
                onDismiss={() => {
                    setShowFeedback();
                }}
                dialogContentProps={{
                    title: 'Санал',
                    type: DialogType.close
                }}
            >
                <div style={{ minWidth: 300 }}>
                    <FieldTextArea onChanged={(pValue) => { setFeedbackNote(pValue); }} placeholder="Саналаа бичнэ үү." />
                    <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                        {loadFeedback == -1 ? <LoadSpin /> : <ButtonDefault onClick={() => onFeedback(showFeedback, "note", feedbackNote, -1, "")} text="Илгээх" />}
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default DiwoAI;